<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-reporte-Diario-export"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Generar Reporte Diario De Cargue
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="Filtros">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="">Fecha Inicial</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_inicial"
                        :class="
                          $v.filtros.fecha_inicial.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                        @input="validaFechas"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="">Fecha Final</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_final"
                        :class="
                          $v.filtros.fecha_final.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                        @input="validaFechas"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="n_guia" class="col-md-5">N° Guía</label>
                    <input
                      type="number"
                      id="n_guia"
                      v-model="filtros.n_guia"
                      class="col-md-7 form-control form-control-sm"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="origen_id" class="col-md-5">Origen</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="origen"
                      placeholder="Producto pozo"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.sitiosOrigenes"
                      :filterable="true"
                      @input="getSelectSitioOrigen()"
                    >
                    </v-select>
                  </div>
                  <div class="form-group row">
                    <label for="destino_id" class="col-md-5">Destino</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="destino"
                      placeholder="Lugar de Destino"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.sitiosDestinos"
                      :filterable="true"
                      @input="getSelectSitioDestino()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="transportadora_id" class="col-md-5"
                      >Empresa Transportadora</label
                    >
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="empresa"
                      placeholder="Empresa"
                      label="razon_social"
                      :options="listasForms.empresas"
                      :filterable="true"
                      @input="getSelectEmpresa()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="placa" class="col-md-5">Placa Vehículo</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="vehiculo"
                      placeholder="Vehiculo"
                      label="placa"
                      :options="listasForms.placas"
                      :filterable="true"
                      @input="getSelectVehiculo()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="sitio_destino_id" class="col-md-5"
                      >Conductor</label
                    >
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="conductor"
                      placeholder="Conductor"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.conductores"
                      :filterable="true"
                      @input="getSelectConductor()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Tipo de Vehículo</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      class="form-control form-control-sm p-0 col-md-7"
                      v-model="tipo_vehiculo"
                      label="nombre"
                      :options="listasForms.tiposVehiculos"
                      @input="seleccionarTipoVehiculo()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="placa" class="col-md-5">Remolque</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="remolque"
                      placeholder="remolque"
                      label="placa"
                      :options="listasForms.remolques"
                      :filterable="true"
                      @input="getSelectRemolque()"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                v-show="!$v.filtros.$invalid"
                @click="generarListadoExcel()"
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.exportReporteDiarioCargue'
                  )
                "
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "ReporteDiarioDeCargueExport",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      guia: [],
      tipo_combustible: [],
      origen: {},
      empresa: {},
      destino: {},
      vehiculo: {},
      remolque: {},
      conductor: {},
      tipo_vehiculo: {},
      bloque: {},
      filtros: {
        n_guia: null,
        origen_id: null,
        destino_id: null,
        fecha_inicial: "",
        fecha_final: "",
      },
      listasForms: {
        tiposVehiculos: [],
        tiposCombustible: [],
        sitiosOrigenes: [],
        sitiosDestinos: [],
        placas: [],
        remolques: [],
        bloques: [],
        empresas: [],
        vehiculos: [],
        conductores: [],
        tipo_operacion: [],
      },
    };
  },
  validations: {
    filtros: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
    },
  },
  methods: {
    validaFechas() {
      if (this.filtros.fecha_inicial) {
        const hoy = new Date();
        const fecha_inicial = new Date(this.filtros.fecha_inicial);
        fecha_inicial.setDate(fecha_inicial.getDate());

        if (fecha_inicial >= hoy) {
          this.filtros.fecha_inicial = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial debe ser menor o igual a la fecha actual...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.filtros.fecha_inicial && this.filtros.fecha_final) {
        var fecha_menor = new Date(this.filtros.fecha_inicial);
        var fecha_mayor = new Date(this.filtros.fecha_final);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.filtros.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial no puede ser mayor a la fecha final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.filtros.fecha_inicial && this.filtros.fecha_final) {
        fecha_menor = new Date(this.filtros.fecha_inicial).getTime();
        fecha_mayor = new Date(this.filtros.fecha_final).getTime();
        var diff = fecha_mayor - fecha_menor;
        var fecha_limite = diff / (1000 * 60 * 60 * 24);
        if (fecha_limite > 31) {
          this.filtros.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `Las fechas no pueden ser mayor a 31 dias...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.filtros.fecha_final) {
        var hoy = new Date();
        const fecha_final = new Date(this.filtros.fecha_final);
        fecha_final.setDate(fecha_final.getDate());
        if (fecha_final >= hoy) {
          this.filtros.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha final debe ser menor o igual a la fecha actual...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },

    seleccionarTipoVehiculo() {
      this.filtros.tipo_vehiculo_id = null;
      if (this.tipo_vehiculo) {
        this.filtros.tipo_vehiculo_id = this.tipo_vehiculo.id;
      }
    },

    getSelectConductor() {
      this.filtros.conductor_id = null;
      if (this.conductor) {
        this.filtros.conductor_id = this.conductor.id;
      }
    },
    getSelectVehiculo() {
      this.filtros.vehiculo_id = null;
      if (this.vehiculo) {
        this.filtros.vehiculo_id = this.vehiculo.id;
      }
    },

    getSelectRemolque() {
      this.filtros.remolque_id = null;
      if (this.remolque) {
        this.filtros.remolque_id = this.remolque.id;
      }
    },

    getSelectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
    },
    getSelectSitioOrigen() {
      this.filtros.origen_id = null;
      if (this.origen) {
        this.filtros.origen_id = this.origen.id;
      }
    },

    getSelectSitioDestino() {
      this.filtros.destino_id = null;
      if (this.destino) {
        this.filtros.destino_id = this.destino.id;
      }
    },

    getSelectBloque() {
      this.filtros.bloque_id = null;
      if (this.bloque) {
        this.filtros.bloque_id = this.bloque.id;
      }
    },

    seleccionarTipoCombustible() {
      this.filtros.tipo_combustible = this.tipo_combustible
        ? this.tipo_combustible.numeracion
        : null;
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/guias/exportReporteDiarioCargue",
        data: { filtros: this.filtros },
      })
        .then((response) => {
          this.cargando = false;
          let data = response.data;
          if (!response.data.error) {
            location.href = data.url;
            this.$swal({
              icon: "success",
              title: response.data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.$swal({
              icon: "error",
              title: response.data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    this.cargando = false;
  },
};
</script>
